import classNames from 'classnames';

import Space from '../../types/UI/Space';

import styles from './HorizontalLine.module.css';

type HorizontalLineProps = {
    space?: Space;
    subtle?: boolean;
    height?: number;
    rounded?: boolean;
};

const HorizontalLine = ({
    space = 'none',
    subtle = false,
    height = 1,
    rounded = false,
}: HorizontalLineProps) => (
    <hr
        style={{ height: height }}
        className={classNames(styles.Root, {
            [styles.rounded]: rounded,
            [styles.subtle]: subtle,
            [styles.spaceNone]: space === 'none',
            [styles.spaceXsmall]: space === 'xsmall',
            [styles.spaceSmall]: space === 'small',
            [styles.spaceMedium]: space === 'medium',
            [styles.spaceLarge]: space === 'large',
            [styles.spaceXlarge]: space === 'xlarge',
        })}
    />
);

export default HorizontalLine;
